/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {
    SELECT_RATINGS_SITE,
    RECEIVE_RATING_DATA,
    RATING_REQUEST_PENDING,
    APPROVING_RATING,
    FETCHING_RATINGS_DATA,
    RECEIVE_RATINGS_UNIT_CHECK
} from 'state/actions/ratingsState/ratingsStatus';



/* ========== ~~~~~~~~~~  OVERLAY STATUS : REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
    selectedSite: null,
    fetchingRatingsData: false,
    isDataReceived: false,
    dataFetchFailed: false,
    requestPending: false,
    requestStatus: null,
    requestSent: false,
    ratingsEmailSentTo: null,
    approving: false,
    ratingUnitUUID: null
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components
const ratingsStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));

    switch (action.type) {
        case SELECT_RATINGS_SITE:
            newState.selectedSite = action.site;
            return newState;
        case RECEIVE_RATING_DATA:
            newState.requestStatus = action.data.requestStatus;
            newState.requestSent = action.data;
            newState.isDataReceived = true;
            newState.dataFetchFailed = false;
            newState.hasRatingsUnit = true;
            return newState;
        case RATING_REQUEST_PENDING:
            newState.requestPending = action.status;
            return newState;
        case APPROVING_RATING:
            newState.approving = action.status;
            return newState;
        case FETCHING_RATINGS_DATA:
            newState.fetchingRatingsData = action.status;
            return newState;
        case RECEIVE_RATINGS_UNIT_CHECK:
            newState.hasRatingsUnit = action.state;
            newState.requestStatus = action.state ? action.state.requestStatus : null;
            newState.ratingsEmailSentTo = action.state ? action.state.userEmail : 'info@insticator.com';
            newState.requestSent = action.state && (action.state.requestStatus === 'PENDING') ? true : false;
            newState.isDataReceived = true;
            newState.dataFetchFailed = false;
            newState.fetchingRatingsData = false;
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ratingsStatus;
